<template>
    <div class="maintainer-list relative">
        <el-page-header @back="goBack" content="服务费明细"></el-page-header>
        <div class="buttons">
            <el-button @click="reset">重置</el-button>
            <el-button @click="search">筛选</el-button>
        </div>

        <el-row class="inputs mg-20" :gutter="20">
            <el-col :md="7" :lg="6" :xl="5" :sm="7" :xs="12">
                <span class="fs-14 pd-r-10">特属服务对象筛选：</span>
                <el-input v-model="search_data" placeholder="姓名或手机号码模糊搜索"></el-input>
            </el-col>
            <el-col :md="7" :lg="6" :xl="6" :sm="7" :xs="12">
                <span class="fs-14 pd-r-10">时间范围：</span>
                <el-date-picker
                    v-model="search_expired_date"
                    type="monthrange"
                    range-separator="至"
                    start-placeholder="开始月份"
                    end-placeholder="结束月份"
                    format="yyyy 年 MM 月"
                >
                </el-date-picker>
            </el-col>
        </el-row>
        <div style="clear: both;display: block;height: 1.5em;line-height: 1.5em;font-weight: bold;font-size: 1.2em;">
            <p style="float: left;">{{ user_name }}  </p>
            <p style="float: right;">月份：{{ month }}</p>
        </div>
        <div style="clear: both;display: block;height: 1.5em;line-height: 1.5em;font-weight: bold;">
            <p style="float: left;">服务报告表</p>
        </div>
        <el-table :data="tableData" border style="width: 100%" :span-method="arraySpanMethod1">
            <el-table-column width="60" prop="no" label="序号" align="center" label-class-name="label"></el-table-column>
            <el-table-column  prop="user_name" label="服务对象" align="center" label-class-name="label"></el-table-column>
            <el-table-column  prop="month_txt" label="服务周期" align="center" label-class-name="label"></el-table-column>
            <el-table-column  prop="times_txt" label="服务期数" align="center" label-class-name="label"></el-table-column>
            <el-table-column  prop="meet_number" label="会面数" align="center" label-class-name="label"></el-table-column>
            <el-table-column  prop="reply_number" label="回复数" align="center" label-class-name="label"></el-table-column>
            <el-table-column prop="health_record_number" label="新增健康档案数" align="center" label-class-name="label"></el-table-column>
        </el-table>

        <div style="clear: both;display: block;height: 1.5em;line-height: 1.5em;font-weight: bold;">
            <p style="float: left;">服务结算表</p>
        </div>
        <el-table :data="tableData" border style="width: 100%" :span-method="arraySpanMethod2">
            <el-table-column width="60" prop="no" label="序号" align="center" label-class-name="label"></el-table-column>
            <el-table-column prop="user_name" label="服务对象" align="center" label-class-name="label"></el-table-column>
            <el-table-column prop="month_txt" label="服务周期" align="center" label-class-name="label"></el-table-column>
            <el-table-column  prop="times_txt" label="服务期数" align="center" label-class-name="label"></el-table-column>
            <el-table-column prop="statement_date" label="结算日期" align="center" label-class-name="label"></el-table-column>
            <el-table-column prop="pay_date" label="付款日期" align="center" label-class-name="label"></el-table-column>
            <el-table-column prop="salary" label="应付报酬" align="center" label-class-name="label"></el-table-column>
        </el-table>
<!--        <el-pagination-->
<!--                class="mg-20 ta-r"-->
<!--                background-->
<!--                layout="total, sizes, prev, pager, next, jumper"-->
<!--                :page-sizes="[10, 25, 50, 100]"-->
<!--                :total="total"-->
<!--                :page-size="perpage"-->
<!--                :current-page="page"-->
<!--                @current-change="changePage"-->
<!--                @size-change="changeSite" :sm="6" :xs="6"-->
<!--        ></el-pagination>-->

        <el-dialog :title="preview_title" :visible.sync="dialogImgFormVisible">
            <el-carousel ref="image_box" id="image_detail" indicator-position="outside" height="500px" :autoplay="false" :initial-index="0" :loop="false">
                <el-carousel-item v-for="(url, n) in imageUrl" :key="n">
                    <div class="image_box">
                        <el-image :src="url"></el-image>
                    </div>
                </el-carousel-item>
            </el-carousel>
        </el-dialog>
    </div>
</template>
<script>
    import {check} from "@/utils/checkData";
    import env from "@/api/env";

    export default {
        data() {
            return {
                user_id: '',
                page: 1,
                perpage: 10,
                total: 0,
                tableData: [],
                userData: [],
                allAmount: 0,
                //搜索栏
                user_role: '3',
                start_date: '',
                end_date: '',
                search_expired_date: '',
                search_data: '',
                is_submit: false,
                dialogImgFormVisible: false,
                preview_title: '',
                imageUrl: [],
                imgPREFIX: env.IMG_COMMON_URL_PREFIX,
                month: '',
                user_name: '',
            };
        },
        created() {
            //获取日志列表
            this.user_id = this.$route.params.user_id;
            this.user_role = this.$route.params.user_role;
            if (this.$route.params.month) {
                this.start_date = this.$route.params.month;
                this.end_date = this.$route.params.month;
            }
            this.getList();
        },
        mounted() {

        },
        methods: {
            arraySpanMethod1({ row, column, rowIndex, columnIndex }) {
                if (row.data_acount === 1) {
                    if (columnIndex === 0) {
                        return [1, 4];
                    } else if (columnIndex === 1
                        || columnIndex === 2
                        || columnIndex === 3) {
                        return [0, 0];
                    }
                }
            },
            arraySpanMethod2({ row, column, rowIndex, columnIndex }) {
                if (row.data_acount === 1 ) {
                    if (columnIndex === 0) {
                        return [1, 6];
                    } else if (columnIndex === 1
                        || columnIndex === 2
                        || columnIndex === 3
                        || columnIndex === 4
                        || columnIndex === 5
                    ) {
                        return [0, 0];
                    }
                }

            },
            //获取日志列表
            getList() {
                let params = {
                    servername: 'Ruyi_StatementsServices',
                    method: 'getSalaryDetail',
                    params: {
                        user_id: this.user_id,
                        user_role: this.user_role,
                        search_data: this.search_data,
                        start_month: this.start_date,
                        end_month: this.end_date,
                    },
                };
                this.$api.service(params).then(res => {
                    if (!check(res)) {
                        this.is_submit = false;
                        return;
                    }
                    let user_data = res.data.data.list.user_data
                    let user_list = user_data.length
                    for (let i = 0; i < user_list; i++) {
                        switch (user_data[i].statement_type) {
                            case '1':
                                user_data[i].statement_type_txt = '银行卡转账';
                                break;
                        }
                    }

                    let list = res.data.data.list.list
                    let list_len = list.length
                    for (let i = 0; i < list_len; i++) {
                        // 序号
                        list[i].no = (this.page - 1) * this.perpage + i + 1
                        if (list[i].data_acount) {
                            list[i].no = '合计'
                        }
                        switch (list[i].statement_type) {
                            case '1':
                                list[i].statement_type_txt = '银行卡转账';
                                break;
                        }
                    }

                    this.tableData = list;
                    this.userData = user_data;
                    this.total = res.data.data.page.count;
                    this.allAmount = res.data.data.list.all_amount;
                    this.month = res.data.data.list.month;
                    this.user_name = res.data.data.list.user_name;
                    this.search_expired_date = [res.data.data.list.start_date, res.data.data.list.end_date]
                    this.is_submit = false;
                }).catch(() => {
                    this.is_submit = false;
                }).finally(() => {
                    this.is_submit = false;
                });
            },
            // 返回上一页
            goBack() {
                window.history.go(-1);
                return;
            },
            //搜索
            search() {
                if (this.is_submit) {
                    // 重复提交提醒
                    this.$message({
                        type: "warning",
                        message: '正在处理请求，请不要重复操作',
                        duration: 1500,
                    });
                    return;
                }
                this.is_submit = true;
                this.page = 1;
                if (this.search_expired_date) {
                    this.start_date = this.search_expired_date[0];
                    this.end_date = this.search_expired_date[1];
                }
                this.getList();
            },

            // 改变每页条数
            changeSite(index) {
                this.perpage = index;
                this.getList();
            },

            //更换页码
            changePage(index) {
                this.page = index;
                this.getList();
            },
            goDetail(item) {

            },
            reset() {
                if (this.is_submit) {
                    // 重复提交提醒
                    this.$message({
                        type: "warning",
                        message: '正在处理请求，请不要重复操作',
                        duration: 1500,
                    });
                    return;
                }
                this.is_submit = true;
                this.user_role = '3';
                this.page = 1;
                this.search_data = '';
                this.start_date = "";
                this.end_date = "";
                this.search_expired_date = "";
                this.getList();
            },
            // 预览
            async previewImage(img, index, title){
                if (this.$refs.image_box) {
                    this.$refs.image_box.setActiveItem(index)
                }
                this.imageUrl = [];

                this.imageUrl.push(this.imgPREFIX + img);

                this.preview_title = title + '的银行卡照片'
                this.active_index = index
                this.dialogImgFormVisible = true;

            },
        }
    };
</script>
<style lang="scss">
    @import "@/styles/common.scss";

    .el-icon-picture-outline,.ad-coentent{color: #6B99F0;cursor: pointer;}
</style>

